import { useEffect } from "react";

export default function useAutoplayVisibility({
  ref,
  start,
  clear,
  threshold = 0.2,
}) {
  // Pause/resume based on element visibility
  useEffect(() => {
    const node = ref?.current;
    if (!node) return;

    let seen = false;
    const io = new IntersectionObserver(
      ([entry]) => {
        const nowVisible =
          entry.isIntersecting && entry.intersectionRatio >= threshold;
        if (nowVisible && !seen) {
          seen = true;
          start();
        } else if (!nowVisible && seen) {
          seen = false;
          clear();
        }
      },
      { root: null, threshold }
    );

    io.observe(node);
    return () => io.disconnect();
  }, [ref, start, clear, threshold]);

  // Pause in background tab; resume on foreground
  useEffect(() => {
    const onVisibility = () => {
      if (document.hidden) clear();
      else start();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, [start, clear]);
}
